//---------------------------
// has outstanding roll-offs
//---------------------------
export default function hasOutstandingRollOffs(dupe_combatants) {
  console.log("---------------------");
  console.log("IN hasOutstandingRollOffs cnt = " + dupe_combatants.length);
  // dupe_combatants.forEach((a) => {
    // console.log(
    //   "hasOutstandingRollOffs name = " +
    //     a.name +
    //     " rank = " +
    //     a.rank +
    //     " dex = " +
    //     a.dex +
    //     " is_ranked = " +
    //     a.is_ranked +
    //     " roll-off = " +
    //     a.roll_off +
    //     " dupe_rank = " +
    //     a.dupe_rank +
    //     " dupe_processed = " +
    //     a.dupe_processed
    // );
  // });
  //-------------------------------------------
  // where not all dupe combatants have rolled
  //-------------------------------------------
  let os = dupe_combatants.some((a) => a.roll_off == 0);
  return os;
}
